<template>
  <v-col>
    <v-row class="mb-8">
      <v-btn
        color="primary"
        @click="CHANGE_ACCESSORI_COMPONENT('Index')"
      >Indietro</v-btn>
    </v-row>
    <v-row
      align="center"
      justify="center"
    >
      <v-card min-width="100%">
        <v-card-text>
          <!-- #datepicker -->
          <v-col>
            <v-row>
              <v-col>
                <v-menu
                  ref="menu"
                  v-model="menu"
                  :close-on-content-click="true"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="posix"
                      label="Data di acquisto"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="posix"
                    no-title
                    scrollable
                    actions
                    locale="it-IT"
                  >
                    <v-spacer></v-spacer>
                    <v-btn
                      text
                      color="primary"
                      @click="menu = false"
                    >OK</v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-col
                class="flex flex-col items-bottm"
                md="1"
              >
                <v-btn
                  style="width: 100%;"
                  color="primary"
                  @click="posix = new Date()"
                >Oggi</v-btn>
              </v-col>
            </v-row>
          </v-col>

          <!-- #form -->
          <v-form
            ref="form"
            v-model="valid"
            :lazy-validation="true"
            autocomplete="off"
          >
            <v-col>
              <v-row>
                <v-col>
                  <v-select
                    label="Fornitore"
                    :items="suppliers"
                    item-text="name"
                    item-value="id"
                    v-model="newAccessory.supplier_id"
                    :rules="[rules.required]"
                    required
                  ></v-select>
                </v-col>
                <v-col>
                  <v-text-field
                    label="EAN"
                    v-model="newAccessory.serial_code"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-col>
            <v-col>
              <v-row>
                <v-col>
                  <v-text-field
                    label="Marchio"
                    v-model="newAccessory.brand"
                    :rules="[rules.required]"
                    required
                  ></v-text-field>
                </v-col>
                <v-col>
                  <v-text-field
                    label="Prodotto"
                    v-model="newAccessory.model"
                    :rules="[rules.required]"
                    required
                  ></v-text-field>
                </v-col>
                <v-col>
                  <v-text-field
                    label="Colore"
                    v-model="newAccessory.color"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-text-field
                    label="Modello"
                    v-model="newAccessory.desctiption"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-text-field
                    label="Costo"
                    type="number"
                    v-model="newAccessory.cost"
                    :rules="[rules.required]"
                    required
                  ></v-text-field>
                </v-col>
                <v-col>
                  <v-text-field
                    label="Prezzo"
                    type="number"
                    v-model="newAccessory.price"
                    :rules="[rules.required]"
                    required
                  ></v-text-field>
                </v-col>
                <v-col>
                  <v-text-field
                    label="Quantità"
                    type="number"
                    v-model="newAccessory.amount"
                    :rules="[rules.required]"
                    required
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-col>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-col>
            <v-row>
              <v-col>
                <v-btn
                  :disabled="!valid"
                  color="success"
                  class="mr-4"
                  @click="submit"
                >
                  Inserici Accessorio
                </v-btn>

                <v-btn
                  color="error"
                  class="mr-4"
                  @click="reset"
                >
                  Reset Modulo
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-card-actions>
      </v-card>
    </v-row>
    <snack-notification :snack="snack" />
  </v-col>
</template>

<script>
  import axios from 'axios'
  import { mapMutations, mapGetters } from 'vuex'

  import SnackNotification from './../../SnackNotification'

  export default {
    name: 'Insert',
    components: {
      SnackNotification
    },
    data() {
      return {
        // #data
        newAccessory: {
          brand: null,
          model: null,
          color: null,
          desctiption: null,
          serial_code: null,
          cost: null,
          price: null,
          amount: null,
          supplier_id: null,
        },
        suppliers: [],
        // #options
        menu: false,
        valid: false,
        snack: {
          error: null,
          visible: null,
          message: null
        },
        // #validation
        rules: {
          required: value => !!value || 'Campo obbligatorio.',
        },
        // #api
        config: {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
          }
        },
      }
    },
    methods: {
      ...mapMutations([
        'CHANGE_ACCESSORI_COMPONENT',
        'SET_ACCESSORY_POSIX'
      ]),
      async getSuppliers() {
        let { data } = await axios.get(`${process.env.VUE_APP_API}/suppliers`, this.config)

        this.suppliers = data
      },
      async submit() {
        if (this.$refs.form.validate()) {

          this.snack = Object.assign({}, {
            error: null,
            visible: null,
            message: null
          })
          this.newAccessory.posix = this.posix

          const { data } = await axios.post(`${process.env.VUE_APP_API}/accessories/create`, this.newAccessory, this.config)

          if (data.status) {

            this.snack = Object.assign({}, {
              visible: true,
              error: false,
              message: 'Articolo salvato correttamente!'
            })
          } else {

            this.snack = Object.assign({}, {
              visible: true,
              error: true,
              message: 'Errore nel salvataggio.'
            })
          }

        }
      },
      reset() {
        this.$refs.form.reset()
      },
    },
    computed: {
      ...mapGetters([
        'getAccessoriesPosix'
      ]),
      posix: {
        get() {
          return this.getAccessoriesPosix
        },
        set(value) {
          this.SET_ACCESSORY_POSIX(value)
        }
      }
    },
    watch: {
      //
    },
    mounted() {
      console.log(this.$store)
      this.getSuppliers()
    }
  }
</script>

<style>
</style>